import { Component, OnInit } from '@angular/core';
import { IDashboardProjOutputModel, IProjDocDashboardOutputModel, IGFCDrawingOutputModel, IDCIAdherenceOutputModel, IStageRevOutputModel, IStageDetailsOutputModel, IJobMHOutputModel, IJobMHInputModel } from 'src/app/ViewModel/DashboardModel';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { CommonService } from 'src/app/Service/Common.service';
import { ChartComponent, LegendTitle, LegendLabelsContentArgs, SeriesLabels } from "@progress/kendo-angular-charts";
import { forkJoin, Observable } from 'rxjs';
import { FormGroup, FormControl } from '@angular/forms';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { Module } from "src/app/Service/element-details.data.service";
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';

@Component({
  selector: 'app-drawing-dashboard',
  templateUrl: './drawing-dashboard.component.html',
  styleUrls: ['./drawing-dashboard.component.css']
})

export class DrawingDashboardComponent implements OnInit {
  dashboardDetails!: IDashboardProjOutputModel;
  totalDays: number = 0;
  completedDays: number = 0;
  remainingDays: number = 0;
  plannedDocuments: number = 0;
  completedDocuments: number = 0;
  balanceDocuments: number = 0;
  plannedManHours: number = 0;
  actualManHours: number = 0;
  balanceManHours: number = 0;
  projectId!: number;
  memberId!: number;
  groupId!: number;
  projectDetails: IProjDocDashboardOutputModel[] = [];
  projectScheduleDetails: IProjDocDashboardOutputModel[] = [];
  projectDocScheduleMHDetails: IProjDocDashboardOutputModel[] = [];
  drawingGFCDetails: IGFCDrawingOutputModel[] = [];
  dciAdherenceDetails: IDCIAdherenceOutputModel[] = [];
  dciRevWiseDetails: IStageRevOutputModel[] = [];
  dciStageWiseDetails: IStageRevOutputModel[] = [];
  dciDiscWiseDetails: IStageRevOutputModel[] = [];
  dciStageRevDetails: IStageDetailsOutputModel[] = [];
  jobMHDetails: IJobMHOutputModel[] = [];

  dciCategories: string[] = [];

  category: string[] = [];
  scheduleCount: number = 0;
  scheduleMHCount: number = 0;
  projectList!: ProjectViewModel[];
  disciplineDetails!: IProjectElementDetailsOutput[];
  StageDetails!: IProjectElementDetailsOutput[];

  selectedProject!: number;
  selectedDiscipline!: number;
  selectedStage!: number;
  selectedProjectCode!: string;
  manHour: number = 0;
  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 1,
    font: "bold 12px Arial, sans-serif",
    position: "insideBase"

  };
  Colors: string[] = ["#5DADE2", "#F7DC6F", "#F1948A"];

  public dynamicHeight = true;
  public searchForm: FormGroup = new FormGroup({
    ctrlProject: new FormControl(),
    ctrlDiscipline: new FormControl(),
    ctrlStage: new FormControl(),
  });
  public data: any[] = [];
  constructor(private _dashboardService: DashboardService, private _commonService: CommonService,
    private projectInfoService: ProjectInfoService, private notificationService: NotificationService,) { }

  ngOnInit() {
    this.memberId = this._commonService.getLoggedInUserId();
    this.groupId = this._commonService.getLoggedInUserGroupId();

    this.getProjectList();
  }

  loadGFCDrawingDetails() {
    this._dashboardService.GetDrawingGFCDetails({ project_Id: this.projectId }).subscribe((res: IGFCDrawingOutputModel[]) => {
      this.drawingGFCDetails = res;
      this.category = res[0].category;
    });
  }

  loadStageWiseDocDetails() {
    this._dashboardService.GetStageWiseDocDetails({ project_Id: this.projectId }).subscribe((res: IStageRevOutputModel[]) => {
      this.dciStageWiseDetails = res;
    });
  }

  loadRevWiseDocDetails() {
    this._dashboardService.GetRevisionWiseDocDetails({ project_Id: this.projectId }).subscribe((res: IStageRevOutputModel[]) => {
      this.dciRevWiseDetails = res;
    });
  }

  loadDiscWiseDocDetails() {
    this._dashboardService.GetDiscWiseDocDetails({ project_Id: this.projectId }).subscribe((res: IStageRevOutputModel[]) => {
      this.dciDiscWiseDetails = res;
    });
  }

  loadDCIAdherenceDetails() {
    this._dashboardService.GetDCiAdherenceDetails({ project_Id: this.projectId }).subscribe((res: IDCIAdherenceOutputModel[]) => {
      this.dciAdherenceDetails = res;
    });
  }

  loadStageRevisionDetails() {
    this._dashboardService.GetStageRevisionWiseDocDetails({ project_Id: this.projectId }).subscribe((res: IStageDetailsOutputModel[]) => {
      this.dciStageRevDetails = res;
      this.dciCategories = this.dciStageRevDetails[0].stages;
    });
  }


  loadJobManhourDetails() {

    let projInput: IJobMHInputModel = {
      project_Code: this.selectedProjectCode
    }

    this._dashboardService.GetJobWiseMHDetails(projInput).subscribe((res: IJobMHOutputModel[]) => {
      let resData: any[] = [{
        status: "Actual",
        actual_Manhour: res[0].actual_Manhour,
        color: "#49cc90"
      }]
      this.data = resData;
      this.manHour = res[0].actual_Manhour;
    });

  }

  getStatusColor(index: number): string {
    return this.Colors[index];
  }


  public categories: string[] = this.category;

  public labelContent(e: any): string {
    return e.category + " : " + e.dataItem.doc_Percentage + " %";
  }

  getProjectList() {
    this.projectInfoService.getProjectList(this.memberId).subscribe((data: ProjectViewModel[]) => {
      this.projectList = data;
      for (let i = 0; i < this.projectList.length; i++) {
        this.projectList[i]['projCodeDesc'] = this.projectList[i].projectCode + ' - ' + this.projectList[i].projectDescription;
      }
    });
  }

  getDisciplineDetails() {
    this.projectInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Workflow, deDescription: 'Workflow Status' }).subscribe((res: IProjectElementDetailsOutput[]) => {
      this.StageDetails = res;
    });
    this.projectInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, deDescription: 'Discipline' }).subscribe((res: IProjectElementDetailsOutput[]) => {
      this.disciplineDetails = res;

    });

  }

  public setSelectedProject(event: any) {
    this.selectedProject = event.value;
    if (this.selectedProject != -2) {
      this.projectId = this.selectedProject;
      this.selectedProjectCode = this.projectList.filter(x => x.projectId == this.selectedProject)[0].projectShortDescription;
      this.loadGFCDrawingDetails();
      this.loadDCIAdherenceDetails();
      this.loadStageWiseDocDetails();
      this.loadRevWiseDocDetails();
      this.loadDiscWiseDocDetails();
      this.loadStageRevisionDetails();
      this.getDisciplineDetails();
      this.loadJobManhourDetails();
    }
    else {
      this.notificationService.showToast("Kindly select Project", "Warning");
    }
  }

  public setSelectedDiscipline(event: any) {
    this.selectedProject = event.value;
    if (this.selectedProject != -2) {
      this.loadDiscWiseDocDetails();
    }
  }

  public setSelectedStage(event: any) {
    this.selectedProject = event.value;
    if (this.selectedProject != -2) {
      this.loadStageRevisionDetails();
    }
  }

} 